export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20warm%20golden%20light%20beams%20piercing%20through%20darkness%20in%20a%20theater%20space%2C%20subtle%20film%20grain%20texture%2C%20elegant%20atmospheric%20smoke%2C%20rich%20deep%20blacks%20with%20amber%20and%20crimson%20highlights%2C%20dramatic%20lighting%20like%20a%20movie%20premiere%2C%20sophisticated%20art%20direction%2C%20no%20text%20no%20people&width=1800&height=1000&seq=hero-movie-bg-01&orientation=landscape"
          alt="极速影视 · 高清电影观影体验"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-0 w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-400 text-sm font-medium mb-6 tracking-wide">
              最新院线同步更新
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold font-heading text-background-50 leading-tight mb-4">
              极速影视<span className="text-accent-400"> · </span>高清大片免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl font-heading text-accent-400 mb-6">
              不缓冲 · 不收费 · 不等待
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              极速影视高清电影大全每日同步院线最新资源，覆盖动作、喜剧、科幻、悬疑、动画等全类型影片。
              无论经典重温还是热门新片，极速影视以流畅不缓冲的播放体验，让你随时随地畅享极致观影。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10000+</div>
                <div className="text-xs text-background-300 mt-1">高清影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-400/30"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">50+</div>
                <div className="text-xs text-background-300 mt-1">每日同步更新</div>
              </div>
              <div className="w-px h-10 bg-background-400/30"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">1080P+</div>
                <div className="text-xs text-background-300 mt-1">全高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 border border-background-300/40 hover:border-accent-400/60 text-background-100 hover:text-accent-400 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>查看专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[460px] md:w-[380px] md:h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20abstract%20composition%20featuring%20dramatic%20light%20rays%20and%20film%20strip%20elements%20on%20a%20dark%20background%2C%20warm%20golden%20and%20crimson%20tones%2C%20lens%20flare%20effects%2C%20elegant%20minimalist%20design%2C%20professional%20cinema%20aesthetic%2C%20no%20text%20no%20people%2C%20high%20contrast%20dramatic%20lighting&width=800&height=1060&seq=hero-poster-01&orientation=portrait"
                alt="极速影视主视觉 - 高清电影在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}